import { Box, Skeleton } from '@mui/material'
import { ReactElement } from 'react'

const MapViewSkeleton = (): ReactElement => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Skeleton variant="rectangular" width="95%" height="95%" />
        </Box>
    )
}

export default MapViewSkeleton
